export const DOMAINS = {
    jira_data: 'https://axillon-orchestration-4034d9a2ff5c.herokuapp.com',
    backend: 'https://api.axillonaerospace.info/api/',
  };